import {DrawingDataItem, DrawingDataItemDrawResult, DrawingDataItemPoint} from "../drawingOnImageDrawingElement.model";

export class DrawingDataItemColumns extends DrawingDataItem {
    constructor() {
        super();
        this.typeValue = 'columns';
        this.properties = {
            origin: undefined,
        }
    }

    public getPointsToMove(): DrawingDataItemPoint[] {
        return [
            DrawingDataItemPoint.fromVisiblePoint(this.properties.origin)
        ];
    }

    public onMouseDown(canvasRelativeX: number, canvasRelativeY: number): DrawingDataItemDrawResult {

        if (this.properties.origin) {
            return {
                changed: false,
                stillDrawing: false
            };
        }

        this.properties.origin = {
            x: canvasRelativeX,
        }
        return {
            changed: true,
            stillDrawing: true
        };
    }

    public onMouseMove(canvasRelativeX: number, canvasRelativeY: number): DrawingDataItemDrawResult {
        this.properties.origin = {
            x: canvasRelativeX,
        }
        return {
            stillDrawing: true,
            changed: true
        };
    }

    public draw(ctx: CanvasRenderingContext2D) {
        if (this.properties.origin) {
            const canvas = ctx.canvas;
            const canvasWidth = canvas.width;
            const canvasHeight = canvas.height;

            const mainLineX = this.properties.origin.x;
            const leftLineX = mainLineX - this.common.size;
            const rightLineX = mainLineX + this.common.size;

            this.applyCommonToCanvas(ctx);

            // Dessiner la ligne principale si elle est dans le canvas
            if (mainLineX >= 0 && mainLineX <= canvasWidth) {
                ctx.beginPath();
                ctx.moveTo(mainLineX, 0);
                ctx.lineTo(mainLineX, canvasHeight);
                ctx.stroke();
            }

            // Dessiner la colonne de gauche si elle est dans le canvas
            if (leftLineX >= 0 && leftLineX <= canvasWidth) {
                ctx.beginPath();
                ctx.moveTo(leftLineX, 0);
                ctx.lineTo(leftLineX, canvasHeight);
                ctx.stroke();
            }

            // Dessiner la colonne de droite si elle est dans le canvas
            if (rightLineX >= 0 && rightLineX <= canvasWidth) {
                ctx.beginPath();
                ctx.moveTo(rightLineX, 0);
                ctx.lineTo(rightLineX, canvasHeight);
                ctx.stroke();
            }
        }
    }
}